import React from "react";
import { MessageCircle, Phone } from "lucide-react";
import { track } from "@/lib/track";

/** Mobile-only sticky bottom bar surfacing the agent's WhatsApp + Call CTAs. */
export default function AgentStickyBottomBar({ agent }) {
  if (!agent) return null;
  const firstName = agent.name?.split(" ")[0] || "Agent";
  const waNum = (agent.phone || "+919999999999").replace(/[^0-9]/g, "");
  const waHref = `https://wa.me/${waNum}?text=${encodeURIComponent(`Hi ${agent.name}, I came in via your INPropPortal page.`)}`;
  const onWa = () => track({ event_type: "wa_click", agent_slug: agent.slug, source: "microsite" });
  const onCall = () => track({ event_type: "call_click", agent_slug: agent.slug, source: "microsite" });

  return (
    <div
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-sg-navy/95 backdrop-blur-md border-t border-white/10 px-4 py-3 flex items-center gap-2 shadow-[0_-8px_24px_rgba(0,0,0,0.25)]"
      data-testid="agent-sticky-bar"
      style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}
    >
      <a
        href={waHref}
        target="_blank"
        rel="noreferrer"
        onClick={onWa}
        className="flex-1 inline-flex items-center justify-center gap-2 rounded-full bg-sg-gold hover:bg-sg-gold-soft text-sg-navy font-semibold h-12"
        data-testid="agent-sticky-wa"
      >
        <MessageCircle className="w-5 h-5" />
        <span>WhatsApp {firstName}</span>
      </a>
      {agent.phone && (
        <a
          href={`tel:${agent.phone}`}
          onClick={onCall}
          aria-label={`Call ${firstName}`}
          className="inline-flex items-center justify-center w-12 h-12 rounded-full border border-sg-gold/60 text-sg-gold"
          data-testid="agent-sticky-call"
        >
          <Phone className="w-5 h-5" />
        </a>
      )}
    </div>
  );
}
